import { render, staticRenderFns } from "./ModalOrte.vue?vue&type=template&id=1f1f8eec&"
import script from "./ModalOrte.vue?vue&type=script&lang=js&"
export * from "./ModalOrte.vue?vue&type=script&lang=js&"
import style0 from "./ModalOrte.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports